import React from "react";

const RatesDownIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="7.545" viewBox="0 0 13.5 7.545">
      <g id="next" transform="translate(0.25 0.295)">
        <g id="next-2" data-name="next" transform="translate(13 -117.742) rotate(90)">
          <g id="Group_16" data-name="Group 16" transform="translate(117.742 0)">
            <path id="Path_16" data-name="Path 16"
                  d="M124.595,6.143l-5.995-6a.5.5,0,0,0-.709.714L123.528,6.5l-5.638,5.639a.5.5,0,1,0,.71.714l6-6a.5.5,0,0,0,0-.714Z"
                  transform="translate(-117.742 0)" fill="#93979b" stroke="#93979b" stroke-width="0.5" />
          </g>
        </g>
      </g>
    </svg>

  );
};

export default RatesDownIcon;
